<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <router-link :to="'/users/detail/info?userid='+ form.user_id">
          <el-breadcrumb-item>{{$route.meta.title}} userid={{form.user_id}}</el-breadcrumb-item>
        </router-link>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               label-width="150px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>投递职位信息</h2>
            <hr>
          </el-col>
          <el-col>
            <el-col :span="12">
              <el-form-item label="岗位名称:">{{positionForm.title}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职位类型:">
                <span v-for="positionType in options.time_periods"
                      v-if="positionType.id === positionForm.position_type">
                  {{positionType.text}}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发布单位:">{{positionForm.employer_name}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发布时间:">
                <span v-if="positionForm.status === 1">{{positionForm.status_updated_at}}</span>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-col style="text-align:center">
            <a :href="form.photo"
               target="_Blank"
               v-if="form.photo">
              <img :src="form.photo+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                   width="100px;"
                   height="100px;"
                   style="border-radius:50px">
            </a>
          </el-col>
          <br/>
          <Br/>
          <el-col>
            <el-form-item label="姓名:">{{form.name}}</el-form-item>
            <el-form-item label="性别:">
              <span v-for="item in options.genders"
                    v-if="item.id === form.gender">{{item.text}}</span>
            </el-form-item>
            <el-form-item label="出生年月:">{{form.brithdate}}</el-form-item>
            <el-form-item label="所在城市:">{{form.address}}</el-form-item>
            <el-form-item label="户口所在地:">{{form.domicile}}</el-form-item>
            <el-form-item label="身高:">{{form.height}}</el-form-item>
            <el-form-item label="学历:">
              <span v-for="item in options.educations"
                    v-if="item.id === form.education">{{item.text}}</span>
            </el-form-item>
            <el-form-item label="联系电话:">{{form.phone_number}}</el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row class="text item">
          <el-col :span="24">
            <h2>工作经验</h2>
            <hr>
          </el-col>

          <el-form-item label="从事过岗位:">
            <span v-for="working_experiences in form.working_experiences">
              <span v-for="item in options.working_experiences"
                    v-if="item.id === working_experiences.id && working_experiences.id !== 99">{{item.text}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="working_experiences.id === 99">{{working_experiences.text}}</span>
            </span>
          </el-form-item>
          <el-form-item label="工作经验:">
            <span v-for="item in options.working_experience_ages"
                  v-if="item.id === form.working_experience_age">{{item.text}}</span>
          </el-form-item>
        </el-row>
        <el-row class="text item">
          <el-col :span="24">
            <h2>求职意向</h2>
            <hr>
          </el-col>
          <el-form-item label="工作性质:">
            <span v-for="item in options.time_periods"
                  v-if="item.id === form.expect_time_period">{{item.text}}</span>
          </el-form-item>
          <el-form-item label="期望从事行业大类:">
            <span v-for="item in options.industries"
                  v-if="item.id === form.expect_industry_type">{{item.text}}</span>
          </el-form-item>
          <el-form-item label="期望工作地点:">
            <span v-if="form.expect_city_info">{{form.expect_city_info.city_name}}</span>
          </el-form-item>
          <el-form-item label="期望薪资:">
            <span v-for="item in options.salary_range"
                  v-if="item.id === form.expect_salary_range">{{item.text}}</span>
          </el-form-item>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>技能/证书/证件</h2>
            <hr>
          </el-col>
          <el-form-item label="证件类别:">
            <span v-for="certificates in form.certificates">
              <span v-for="item in options.certificates"
                    v-if="item.id === certificates.id && certificates !== 99">{{item.text}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="certificates.id === 99">{{certificates.text}}</span>
            </span>
          </el-form-item>
        </el-row>
        <br/>

        <el-row class="text item">
          <el-col :span="24">
            <h2>自我介绍</h2>
            <hr>
          </el-col>
          {{form.self_introduce}}
        </el-row>
        <el-col :span="8"
                :offset="6">
          <Br/><br/>
          <el-button type="primary"
                     @click="dialogVisible = true">转发简历
          </el-button>&nbsp;&nbsp;&nbsp;&nbsp;
          <router-link :to="{path: '/resume/audit-table',query:{id:positionId}}">
            <el-button>返回</el-button>
          </router-link>
        </el-col>
      </el-form>
    </layout-panel>
    <el-dialog :visible.sync="dialogVisible"
               width="30%"
               center>
      <span>确认将该简历转发至招聘方邮箱吗?</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onsendResumes()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      id: this.$route.query.id,
      positionId: this.$route.query.position_id,
      form: {
        name: null,
        gender: null,
        brithdate: null,
        address: null,
        domicile: null,
        height: null,
        education: null,
        photo: null,
        phone_number: null,
        working_experiences: [],
        working_experience_age: null,
        certificates: [],
        self_introduce: '', // 自我介绍
        expect_industry_type: null,
        expect_city_name: null,
        expect_salary_range: null,
        expect_time_period: null,
        expect_city_info: [],
        user_id: null,
      },
      positionForm: {
        title: null,
        position_type: null,
        employer_name: null,
        status_updated_at: null,
        status: null,
      },
      options: {
        genders: [],
        educations: [],
        cities: [],
        industries: [],
        salary_range: [],
        position: [],
        experience: [],
        certificates: [],
        expect_cities: [],
        working_experiences: [],
        working_experience_age: [],
        time_periods: [],
        working_experience_ages: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getPostionForm', this.positionId),
      request('getResumeForm', this.id),
      request('getResumeOptions'),
      request('appliedResume', {
        id: this.id,
        positionId: this.positionId,
      }),
    ]).then(([positionForm, form, options]) => {
      ((data) => {
        filter.setLoop(this.positionForm, data)
      })(positionForm)
      ;((data) => {
        filter.setLoop(this.form, data.data)
      })(form)
      ;((data) => {
        filter.setLoop(this.options, data.data)
      })(options)
    })
  },
  methods: {
    ...Vuex.mapActions(['getResumeForm', 'appliedResume', 'sendResumes', 'getPostionForm', 'editPostionOptions']),
    onsendResumes () {
      let data = {
        position_id: this.positionId,
        resume_ids: [this.id],
      }
      return request.common('sendResumes', data).then((res) => {
        this.$message({
          showClose: true,
          message: '转发简历成功',
          type: 'success',
        })
        this.$router.push({path: '/resume/audit-table?id=' + this.positionId})
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/resume/pages/ResumeAuditDetail.vue